import Vue from "vue";
import CognitoAuth from "./cognito";
import config from "@/config/cognito";

Vue.use(CognitoAuth, config);

export default new CognitoAuth();
